<template>
<div v-if="userStore.current_user_groups.includes('ADMIN_PANEL') || userStore.isImpersonating">
    <h1>{{ userFirstName + ' ' + userLastName }}</h1>
    <h2>Rôles&nbsp;:</h2>
    <div class="user_flags">   
        <p v-for="item in userStore.backend_groups" :key="item">
            <SwitchButton
                :checked="localgroups.includes(item)"
                @update:checked="checked => {
                    if (checked) {
                        if (!localgroups.includes(item)) localgroups.push(item)
                    } else {
                        localgroups = localgroups.filter(groupe => groupe !== item)
                    }
                }"
                :label_right="item"
            />
        </p>
    </div>
    
    <div class="button-group">
        <button class="primary-button" @click="handleRoles('ADD')"><i class="material-icons">add_moderator</i>&nbsp;Ajouter tous les rôles</button>
        <button class="warning-button-outlined" @click="handleRoles('DELETE')"><i class="material-icons">remove_moderator</i>&nbsp;Retirer tous les rôles</button>
    </div>
</div>
<div v-else>
    <h1>{{ userFirstName + ' ' + userLastName }}</h1>
    <p>{{ userStore.current_user.email }}</p>
    <p><b>Mes rôles&nbsp;:</b></p>
    <div class="role-list">
        <p v-for="item in userStore.current_user_groups"><span>{{ item }}</span></p>
    </div>
</div>

<PopUp 
    v-model:show="showPopup"
    :popupBackgroundColor="popupType === 'success' ? '#4caf50' : popupType === 'error' ? '#f44336' : '#2196f3'"
    :duration="2000"
    position="center"
    >
    <p style="color:white; font-weight:600;">{{ popupMessage }}</p>
</PopUp>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { useUserStore }          from '@/stores/userstore'
import SwitchButton              from './SwitchButton.vue';
import apiClient                 from '@/api';
import PopUp                     from './PopUp.vue';

const userStore = useUserStore();

const emits = defineEmits(['closeMe'])
const props = defineProps({
    user: Object
})

const userFirstName  = ref([])
const userLastName   = ref([])

const localgroups    = ref([])
const lastSentGroups = ref([])

const popupMessage   = ref('');
const popupType      = ref('success');
const showPopup      = ref(false);

watch(localgroups, async (newVal) => {
    console.log('changed');
    
    // Vérifier si la nouvelle valeur est vraiment différente avant d'envoyer une requête
    if (JSON.stringify(newVal) !== JSON.stringify(lastSentGroups.value)) {
        try {
            // console.log("Sent:", JSON.stringify(newVal));
            const formData = new FormData()
            formData.append('groups', JSON.stringify(newVal))
            if (props.user) {
                formData.append('userId', props.user.id)
            }

            console.log(formData.get('userId'))

            const response = await apiClient.post("update_user_groups/", formData);
            console.log("Received:", response.data.new_groups);

            // Mettre à jour lastSentGroups pour éviter un nouvel envoi immédiat
            lastSentGroups.value = [...response.data.new_groups]

            if (!props.user || props.user.id === userStore.current_user.id) {
                // On n'attend pas la réponse du back pour redéfinir les droits de l'user
                localStorage.setItem("mapped_groups", JSON.stringify(newVal))
                
                // Mettre à jour current_user_groups uniquement si différent
                if (JSON.stringify(userStore.current_user_groups) !== JSON.stringify(response.data.new_groups)) {
                    userStore.current_user_groups = response.data.new_groups
                    console.log(response.data.new_groups);
                    localStorage.setItem('mapped_groups', JSON.stringify(response.data.new_groups))
                }
            }


        } catch (error) {
            console.error("Error updating user groups:", error);
        }
    }
}, { deep: true });  // Surveiller les modifications dans le tableau


// recovers roles by user id
const getUserRoles = async () => {
    const params = {
        userId: props.user.id
    }

    try {
        const response = await apiClient.get('get_user_roles/', { params })

        localgroups.value = [...response.data.data]
        lastSentGroups.value = [...response.data.data]
    
    } catch (error) {
        if (error.response) {
            console.log('Status : ', error.response.status)
            console.log('Message : ', error.response.message)
        } else if (error.request) {
            console.log('No response received : ', error.request)
        } else {
            console.log('Error : ', error.message)
        }
    }
}

// adds or deletes roles all roles for a user
const handleRoles = async (action) => {
    const formData = new FormData()
    formData.append('type', action)

    if (props.user) {
        formData.append('user', props.user.id)
    }

    try {
        await apiClient.post('user_roles/', formData)

        // getUserRoles()

        if (action === 'ADD') {
            localgroups.value    = Object.values(userStore.backend_groups)
            lastSentGroups.value = [...localgroups.value]
            showPopupMessage(`L'ajout de tous les rôles à l'utilisateur ${userFirstName.value} ${userLastName.value} a été réalisé avec succès.`, 'success')
        } else {
            localgroups.value    = []
            lastSentGroups.value = []
            showPopupMessage(`La suppression de tous les rôles de l'utilisateur ${userFirstName.value} ${userLastName.value} a été réalisée avec succès.`, 'success')
        }

        if (!props.user || props.user.id === userStore.current_user.id) {
            userStore.current_user_groups = [...localgroups.value]
            localStorage.setItem('mapped_groups', JSON.stringify(userStore.current_user_groups))
        }

    } catch (error) {
            showPopupMessage("Erreur lors de la requête");
    }
}

// popup message
const showPopupMessage = (msg, type = 'success') => {
    popupMessage.value = msg;
    popupType.value = type;
    showPopup.value = true;
};

onMounted(() => {
    if (props.user) {
        getUserRoles()
        userFirstName.value = props.user.firstName
        userLastName.value  = props.user.lastName
    } else {
        localgroups.value = [...userStore.current_user_groups]
        lastSentGroups.value = [...userStore.current_user_groups]
        userFirstName.value = userStore.current_user.first_name
        userLastName.value = userStore.current_user.last_name
    }
})

</script>

<style lang="scss" scoped>

.user_flags{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 0rem 2rem;
    p{
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
        
    }
}

.button-group {
    margin-top: 1rem;
    display: inline-grid;
    grid-auto-columns: max-content;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    button {
        justify-content: center;
        width: 100%;
    }
}

h1 {
    color: $pale-blue;
}

.role-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    p {
        margin: 0;
        padding: 4px 12px;

        border-radius: 6px;

        background-color: $ciel-blue;
        color: #000;
    }
}

html label, body label {
    gap: 0;
}
</style>